/* DNA-Comment: Gatsby shadow component for carbon gatsby theme. TODO - Remove 9-point icon. */
import React from "react"
import Switcher from 'gatsby-theme-carbon/src/components/Switcher/Switcher';

const CustomSwitcher = props => <Switcher {...props} />;

export default CustomSwitcher;